import { axios } from '@/services/axios';

export const deleteTRSRegistration = (registrationID, requiredScope) => {
    const endpoint = `/TRSRegistration/${registrationID}`;
    return axios.delete(endpoint, {
        'X-RequestScope': requiredScope,
    });
};
